module.exports = __webpack_public_path__ + "img/iosImg.4bf4e683.png";